import React from "react";

const STATUS_META = {
  pending: {
    label: "Pending review",
    className: "bg-amber-100 text-amber-800 border-amber-200",
  },
  processing: {
    label: "Processing",
    className: "bg-blue-100 text-blue-800 border-blue-200",
  },
  successful: {
    label: "Successful",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  approved: {
    label: "Successful",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  completed: {
    label: "Successful",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  rejected: {
    label: "Rejected",
    className: "bg-rose-100 text-rose-800 border-rose-200",
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-slate-100 text-slate-700 border-slate-200",
  },
};

const normaliseStatus = (status) => String(status || "successful").trim().toLowerCase();

const TransactionStatusBadge = ({ status, label }) => {
  const key = normaliseStatus(status);
  const meta = STATUS_META[key] || {
    label: label || key.replace(/_/g, " "),
    className: "bg-slate-100 text-slate-700 border-slate-200",
  };

  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-semibold capitalize ${meta.className}`}
    >
      {label || meta.label}
    </span>
  );
};

export default TransactionStatusBadge;
